// src/components/LevelIcons.js
import { HiAcademicCap } from 'react-icons/hi';
import { FaRocket } from 'react-icons/fa';
import { RiStarLine, RiStarHalfLine, RiStarSLine } from 'react-icons/ri';
import { GiProgression, GiSunglasses, GiLaurelsTrophy } from 'react-icons/gi';
import { MdWhatshot } from 'react-icons/md';

// Centralized icon mapping matching LevelProgressPath component
export const LEVEL_ICON_MAP = {
  0: RiStarLine,         // AI Noob (pre-level)
  1: RiStarHalfLine,     // AI Novice
  2: RiStarSLine,        // AI Explorer
  3: GiProgression,      // AI Practitioner
  4: FaRocket,           // AI Specialist
  5: GiSunglasses,       // AI Expert
  6: MdWhatshot,         // AI Master
  7: GiLaurelsTrophy     // AI Guru
};

export const LEVEL_NAME_ICON_MAP = {
  'AI Noob': RiStarLine,
  'AI Novice': RiStarHalfLine,
  'AI Explorer': RiStarSLine,
  'AI Practitioner': GiProgression,
  'AI Specialist': FaRocket,
  'AI Expert': GiSunglasses,
  'AI Master': MdWhatshot,
  'AI Guru': GiLaurelsTrophy
};

export function getLevelIcon(level, levelName) {
  if (levelName && LEVEL_NAME_ICON_MAP[levelName]) {
    return LEVEL_NAME_ICON_MAP[levelName];
  }
  if (LEVEL_ICON_MAP[level] !== undefined) {
    return LEVEL_ICON_MAP[level];
  }
  return HiAcademicCap;
}
